/* eslint-disable sort-imports */
import BaseComponent from "../../base-component"
import {FlatList} from "react-native"
import memo from "set-state-compare/build/memo.js"
import React from "react"
import {shapeComponent} from "set-state-compare/build/shape-component.js"

export default memo(shapeComponent(class SharedTagble extends BaseComponent {
  render() {
    const {style, ...restProps} = this.props
    const actualStyle = Object.assign( // eslint-disable-line prefer-object-spread
      {width: "100%"},
      style
    )

    return (
      <FlatList style={actualStyle} {.../** @type {any} */ (restProps)} />
    )
  }
}))
